import api from '../../plugins/api';

const getCrmSidebarNotificationsCount = (params) => {
  return api.get('/api/notifications/sidebar/getCrmSidebarNotificationsCount', params);
};

export default getCrmSidebarNotificationsCount;
